import Dialog from 'material-ui/Dialog';
import Close from 'material-ui/svg-icons/navigation/close';
import PropTypes from 'prop-types';
import r from 'render-dom';
import styled from 'styled-components';

import './index.css';

const StyledDialog = styled(Dialog)`padding-top: 0 !important;`;

const baseStyle = {
    button: {
        marginTop: -4,
        textTransform: 'uppercase',
    },
    closeButton: {
        cursor: 'pointer',
        display: 'inline-block',
        fontSize: 12,
        position: 'absolute',
        right: 20,
        textAlign: 'center',
        textDecoration: 'none',
        top: 15,
    },
    esc: { color: '#bbb' },
};

function Modal({
    children,
    className,
    open = true,
    onClose = () => {},
    showCloseButton = true,
    style = {},
}) {
    return (
        r(StyledDialog, {
            autoScrollBodyContent: true,
            bodyStyle: { borderRadius: 10, padding: '50px' },
            className,
            contentStyle: { maxWidth: 700, ...style },
            disableEscapeKeyDown: false,
            modal: true,
            onRequestClose: () => onClose(),
            open,
        }, [
            r.div([
                r.div({
                    isRendered: showCloseButton,
                    onClick: () => onClose(),
                    style: baseStyle.closeButton,
                }, [
                    r(Close, { style: baseStyle.esc }),
                    r.div({ style: { ...baseStyle.esc, ...baseStyle.button } }, ['ESC']),
                ]),
                children,
            ]),
        ])
    );
}

export default Modal;

Modal.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    onClose: PropTypes.func,
    showCloseButton: PropTypes.bool,
    showModal: PropTypes.bool,
    style: PropTypes.object,
};
